import { render, staticRenderFns } from "./PromotionStepGeneralInfo.vue?vue&type=template&id=b171808e&scoped=true&"
import script from "./PromotionStepGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./PromotionStepGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./PromotionStepGeneralInfo.vue?vue&type=style&index=0&id=b171808e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b171808e",
  null
  
)

export default component.exports